import {
  CHECK_CIRCLE_V2,
  CLOCK_ICON,
  EDUCATION_ICON,
  FINANCES_ICON,
  HEALTH_ICON,
  PROTECTION_ICON,
  REWARDS_ICON,
  WELL_BEING_ICON,
  XERROR_ICON
} from './images';
import { categoryKeys } from '../types/benefitTypes';
import { CategoryIconsType } from '../types/types';

export const MONTHLY_PERIOD_OPTION = 'monthly';
export const HISTORICAL_PERIOD_OPTION = 'historical';

export const CATEGORY_ICONS: CategoryIconsType = {
  '5': WELL_BEING_ICON,
  '6': HEALTH_ICON,
  '7': EDUCATION_ICON,
  '8': FINANCES_ICON,
  '10': PROTECTION_ICON,
  '100': REWARDS_ICON
};

export const BENEFITS_SOURCE_SUPPLEMENTARY_TYPES = [
  'supplemental-health-insurance',
  'supplemental-life-insurance',
  'supplemental-dental-insurance',
  'supplemental-catastrophic-insurance'
] as const;

export const INSURANCE_SOURCE_TYPE = 'insurance';
export const FLEXIBLE_REMUNERATION_SOURCE_TYPE = 'flexible-remuneration';

export const HEALTH_INSURANCE_SUB_SOURCE_TYPE = 'health-insurance';

export const TRANSLATIONS_BENEFIT_CATEGORIES: { [key in categoryKeys]: string } = {
  wellbeing: 'global.wellbeing.main',
  education: 'global.learning',
  recognition: 'global.recognition.main',
  finance: 'global.finance.main',
  health: 'global.health.main'
};

export const MARKETCARE_INSURANCE_DESCRIPTION_KEY =
  'collaborators.global.market_care_insurance_state.active.description';
export const BENEFIT_PROCESSING_STATUS_KEY = 'collaborators.global.insurance_state.processing.description';

export const BENEFIT_PROVIDER_STATUS_DATA = {
  active: {
    tagVariant: 'success',
    icon: CHECK_CIRCLE_V2,
    descriptionKey: 'collaborators.global.insurance_state.active.description'
  },
  missing_data: {
    tagVariant: 'info',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.pending_question.description'
  },
  accepted: {
    tagVariant: 'success',
    icon: CHECK_CIRCLE_V2,
    descriptionKey: 'collaborators.global.insurance_state.active.description'
  },
  pending_dps: {
    tagVariant: 'info',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.pending_document.description'
  },
  pending_question: {
    tagVariant: 'info',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.pending_question.description'
  },
  inactive_dps: {
    tagVariant: 'inactive',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.to_activate.description'
  },
  inactive_complementary: {
    tagVariant: 'inactive',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.complementary_inactive.description'
  },
  pending_user_acceptance: {
    tagVariant: 'inactive',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.pending_user_acceptance.description'
  },
  process_acceptance: {
    tagVariant: 'info',
    icon: CLOCK_ICON,
    descriptionKey: 'collaborators.global.insurance_state.pending_approval.description'
  },
  in_process: {
    tagVariant: 'inactive',
    icon: CLOCK_ICON,
    descriptionKey: BENEFIT_PROCESSING_STATUS_KEY
  },
  rejected: {
    tagVariant: 'error',
    icon: XERROR_ICON,
    descriptionKey: 'collaborators.global.insurance_state.activation_rejected.description'
  }
} as const;

export const ACTIVATE_MARKETCARE_LINK = 'https://app.market-care.com/es/activa-tu-cuenta';

export const BENEFIT_REWARDS_SKU = 'wallet';
